<div class="main-section-container custom-scrollbar">
  <div class="container-fluid portal-name" [innerHTML]="supplierHeaderText"
  style="padding:15px;max-width: 1300px;">
  </div>
  <section id="do-business">
    <div class="sign-up-container">
      <div class="register-container">
        <ngx-loading [show]="isBusy || isSubmit" [config]="loaderConfig"></ngx-loading>
        <h3 class="register-container-title" *ngIf="!isBusy">SIGN UP</h3>
        <div class="container-fluid">
          <div class="col-md-12 text-center title floating-form" *ngIf="!isBusy">
            <section *ngIf="detailObject" id="loginForm">
              <form #supplierForm="ngForm" novalidate>
                <ng-container *ngIf="detailObject.Sections">
                  <ng-container *ngFor="let section of detailObject.Sections">
                    <ng-container *ngFor="let group of detailObject.Groups">
                      <ng-container *ngFor="let property of detailObject.Properties;">
                        <ng-container *ngIf="property.PropertyFormControlType.toUpperCase() == 'SECURETEXTBOX' || property.PropertyFormControlType.toUpperCase() == 'TEXTBOX' 
                        || property.PropertyFormControlType.toUpperCase() == 'PASSWORD'">
                          <div *ngIf="property.PropertyValidation; else noValidate" class="floating-label {{property.PropertyName}}-label">
                            <input #textbox appBlockCopyPaste [disabled]="!property.PropertyIsEditable"
                              [id]="property.PropertyName"
                              [allowBlock]="property.PropertyFormControlType.toUpperCase() == 'SECURETEXTBOX' || property.PropertyFormControlType == 'Password'"
                              [type]="property.PropertyFormControlType" 
                              [ngClass]="{'floating-input': true, 'form-control':true, 'is-invalid': submitted && PropertyValue.invalid, 
                              'has-value': textbox.value, 'uppercase': property.PropertyDisplayFormat == 'UPPER' }" 
                              placeholder=" " 
                              [value]="property.PropertyValue"
                              [attr.disabled]="isSubmit ? true : null"
                              [attr.name]="property.PropertyName"
                              [name]="property.PropertyName"
                              autocomplete="new-password"
                              [(ngModel)]="property.PropertyValue"
                              #PropertyValue="ngModel"
                              [ngModelOptions]="{ updateOn: 'blur' }"
                              (change)="onValueChange(property, textbox.value)"
                              [pattern]="property.PropertyValidation.PropertyFormat ? property.PropertyValidation.PropertyFormat : null" 
                              [maxlength]="property.PropertyValidation.PropertyLength == 0 ? null : property.PropertyValidation.PropertyLength" 
                              [required]="property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory : null">
                            <span></span>
                            <label>{{ property.PropertyDisplay }}
                              <ng-container *ngIf="property.PropertyValidation">
                                <span *ngIf="property.PropertyValidation.IsMandatory" class="mandatory"></span>
                              </ng-container>
                            </label>
                            <div *ngIf="PropertyValue.invalid" class="invalid-feedback" style="color: #bd4e5a;padding: 0 5px;">
                              <div *ngIf="PropertyValue.errors.noMatch">{{property.ParentPropertyName ? property.ParentPropertyName : property.PropertyName}} does not match</div>
                              <div *ngIf="PropertyValue.errors.required">{{ property.PropertyDisplay }} is required</div>
                              <div *ngIf="PropertyValue.errors.maxlength">{{ property.PropertyDisplay }} cannot be more than {{ property.PropertyValidation.PropertyLength }}</div>
                              <div *ngIf="PropertyValue.errors.pattern">{{ property.PropertyValidation.FormatValidationMessage }}</div>
                            </div>
                          </div>
                          <ng-template #noValidate>
                            <div class="floating-label">
                              <input #textbox appBlockCopyPaste [disabled]="!property.PropertyIsEditable"
                              [ngClass]="{'uppercase': property.PropertyDisplayFormat == 'UPPER'}"
                              [id]="property.PropertyName"
                              [allowBlock]="property.PropertyFormControlType.toUpperCase() == 'SECURETEXTBOX' || property.PropertyFormControlType == 'Password'"
                              [type]="property.PropertyFormControlType" 
                              [name]="property.PropertyName"
                              autocomplete="new-password"
                              class="floating-input" 
                              placeholder=" " 
                              [attr.disabled]="isSubmit ? true : null"
                              [value]="property.PropertyValue"
                              (change)="onValueChange(property, textbox.value)">
                              <label>{{ property.PropertyDisplay }}</label>
                            </div>
                          </ng-template>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <!-- <ng-container *ngIf="detailObject.Actions.length > 0">
                  <div class="floating-label" *ngFor="let action of detailObject.Actions">
                    <input type="button" *ngIf="!action.DisplayOnGroup" (click)="submitForm(action);" value="Register as a supplier" class="a-button-primary yellow" />
                  </div>
                </ng-container> -->
                <div class="recaptcha" *ngIf="enableCaptcha">
                  <re-captcha (resolved)="resolved($event)" 
                    [(ngModel)]="detailObject.Captcha"
                    name="captcha"
                    required
                    siteKey="{{siteKey}}"
                    #captchaControl="ngModel"></re-captcha>
                    <div *ngIf="!captchaControl.valid && submitted" style="color:#f44336;font-size: 13px;text-align: left">Captcha must be solved</div>
                </div>
                <div class="floating-label">
                  <input type="button" (click)="submitForm('SUBMITNEWSUPPLIER', supplierForm);" value="Register as a supplier" class="a-button-primary register-button" id="register-button"/>
                </div>
              </form>
            </section>
          </div>
        </div>
        <p class="verify-email-text" *ngIf="!isBusy">If you did not receive your verification email, you can <a href="javascript:void(0)" (click)="resendVerificationEmail()">resend your verification email</a></p>
      </div>
      <div class="register-note" *ngIf="registerNote && registerNote !== ''">
        <h3 class="register-container-title" *ngIf="!isBusy">Note</h3>
        <div class="container-fluid portal-name" [innerHTML]="registerNote"></div>
      </div>
    </div>
    <div class="business-image-wrapper" [ngStyle]="{'background-image': 'url('+supplierBackdrop+')'}"></div>
  </section>
  <div [innerHTML]="supplierReg | safe_html"></div>
  <!-- <section id="training-help">
      <div class="container-fluid training-help-container">
        <div class="row">
          <div class="col-sm-6 text-center">
            <div class="training-help-section">
              <img src="../../assets/images/success_ic.png" />
              <p>Your success is important to us</p>
              <p>Get all the information you need from our training guides</p>
              <p style="text-align: center;">For any inquiries</p>
              <div class="th-input-case">
                <input type="submit" value="Go to training >" class="a-button-primary blue" />
              </div>
            </div>
          </div>
          <div class="col-sm-6 text-center">
            <div class="training-help-section">
              <img src="../../assets/images/faq_ic.png" />
              <p>Need help?</p>
              <p>Ask our support team</p>
              <p class="text-center">What are you waiting for? Join our supplier network today.</p>
              <div class="th-input-case">
                <input type="submit" value="Contact Us >" class="a-button-primary blue"/>
              </div>
            </div>
          </div>
        </div>
      </div>
  </section> -->
</div>